<style scoped>
.day_header {
	background-color: white;
	text-align: center;
	height: 50px;
	padding-top: 10px;
}

.day_selected {
	background-color: #FFFFE0;
}

.day_content {
	padding: 5px;
}

</style>

<template>
	<div>
		<div :class="{ 'day_header': true, 'day_selected': is_selected_date }">
			<div>{{ day.text }}</div>
		</div>
		<div class="day_content">
			<v-alert type="error" v-if="errormsg != ''">{{
				errormsg
			}}</v-alert>

			<v-task-item
				v-for="task in tasks" 
				:key="task.id"
				:task="task"
				@click="$router.push({ name: 'View Task', params: { 'id': task.id }})"
				@stop_recording="$emit('stop_recording')"
			/>

			<!--<div v-if="loading">
				<v-skeleton-loader
					type="list-item-avatar-two-line"
					width="100%"
				/>
			</div>-->
		</div>
	</div>
</template>

<script>
import task_item from "@/components/tasks/task_item"
import moment from 'moment';

export default {
	components: {
		'v-task-item': task_item
	},
	data() {
		return {
			errormsg: "",
			loading: false,
			tasks: []
		}
	},
	props: {
		day: {
			type: Object,
			default: null
		},
		is_selected_date: {
			type: Boolean,
			default: false
		},
		statusses: {
			type: Array,
			default: null
		},
		inc_team_tasks: {
			type: Boolean,
			default: false
		},
	},
	mounted() {
		this.load_tasks();
	},
	methods: {
		load_tasks() {
			let self = this;
			this.tasks = [];
			this.loading = true;
			this.errormsg = "";

			// build our url parameters
			let params = new Array();
			if (this.inc_team_tasks) {
				params.push("assign_mode=1"); // including my teams task
			} else {
				params.push("assign_mode=0"); // just my tasks
			}
			params.push("date_mode=2"); // date range
			params.push("start_date=" + this.day.value);
			params.push("end_date=" + this.day.value);
			params.push("statusses=" + this.statusses);

			// build our url, we have to add url escaping here!
			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						const compare_arr = JSON.parse(JSON.stringify(json.data));
						compare_arr.forEach(d => {
							if (d.start_time.length !== 0) {
								const time_str = moment(d.start_time, "hh:mmA").format();
								const time = new Date(time_str).getTime();
								d['time_compare'] = time;
							} else {
								d['time_compare'] = 0;
							}
						});

						const compare_arr_A = compare_arr.filter(c => { return c.time_compare !== 0 });
						const compare_arr_B = compare_arr.filter(c => { return c.time_compare === 0 });

						compare_arr_A.sort((a,b) => { return a.time_compare - b.time_compare });					
						compare_arr_B.sort((a,b) => { return a.id - b.id });	
						
						const task_res = [...compare_arr_A, ...compare_arr_B];

						self.tasks = task_res;
					} else {
						self.errormsg = json.reason;
					}					
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					self.errormsg = e.message;
					console.log(e);
				})
				.finally(function() {
					self.loading = false
				})
		}
	},
	watch: {
		'day.value': function() {
			this.load_tasks();
		},
		'inc_team_tasks': function() {
			this.load_tasks();
		},
		'statusses': function() {
			this.load_tasks();
		}
	}
}
</script>